

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATECONTACTUSSECTIONFORREAPPROVAL
// UPDATECONTACTUSSECTIONFORREAPPROVAL


const UPDATECONTACTUSSECTIONFORREAPPROVAL= createAsyncThunk(
  "updateContactUsSectionForReApproval/updateContactUsSectionForReApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateContactUsSectionForReApprovalSlice = createSlice({
  name: "updateContactUsSectionForReApprovalSlice",
  initialState: {
    updateContactUsSectionForReApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateContactUsSectionForReApproval: (state) => {
        state.updateContactUsSectionForReApproval.loading = false
        state.updateContactUsSectionForReApproval.error = false
        state.updateContactUsSectionForReApproval.data = []
        state.updateContactUsSectionForReApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATECONTACTUSSECTIONFORREAPPROVAL.fulfilled, (state, action) => {
      state.updateContactUsSectionForReApproval = {
        ...state.updateContactUsSectionForReApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONTACTUSSECTIONFORREAPPROVAL.pending, (state, action) => {
      state.updateContactUsSectionForReApproval = {
        ...state.updateContactUsSectionForReApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATECONTACTUSSECTIONFORREAPPROVAL.rejected, (state, action) => {
      state.updateContactUsSectionForReApproval = {
        ...state.updateContactUsSectionForReApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateContactUsSectionForReApprovalAction = {
    UPDATECONTACTUSSECTIONFORREAPPROVAL,
};

export { updateContactUsSectionForReApprovalAction };
export default updateContactUsSectionForReApprovalSlice.reducer;
export const {setInitialStateOfupdateContactUsSectionForReApproval} = updateContactUsSectionForReApprovalSlice.actions
